/**
 * @name 推广活动
 */
import store from '@/store'
import request from '../request'
import qs from 'qs'

const addUid = (params) => {
  return { ...params, inviterId: store.state.auth.userId }
}

/**
 * 根据id获取活动详情
 * 邀请好友乘客领2*5元优惠券 212570000006
 * 邀请车主领13元现金 212570000009
 * @param {*} activityId
 * @returns
 */
export const getActivityInfoById = (activityId) => {
  return request({
    url: '/app/activity/getActivityInfoById',
    method: 'GET',
    params: { activityId }
  })
}

/**
 * 邀请活动参与-获取用户已邀请信息
 * @param {*} inviterId
 * @param {*} activityId
 * @param {*} current
 * @param {*} size
 * @returns
 */
export const getActivityInviteInfo = (data) => {
  return request({
    url: '/app/activity/getActivityInviteInfo',
    method: 'POST',
    data: addUid(data)
  })
}

/**
 * 获取活动短信验证码
 * @param {*} mobile
 * @param {*} activityId
 * @returns
 */
export const getJoinActivityMobileCode = (data) => {
  return request({
    url: '/app/user/login/getJoinActivityMobileCode',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/**
 * 邀请活动参与-活动入口
 * @param {*} inviterId
 * @param {*} activityId
 * @param {*} inviteeMobile
 * @param {*} verifyCode
 * @returns
 */
export const joinActivity = (data) => {
  return request({
    url: '/app/activity/joinActivity',
    method: 'POST',
    data: addUid(data)
  })
}

/**
 * 邀请活动优惠券列表
 * @param {*} activityId
 * @param {*} activityId
 * @returns
 */
export const getNewUserCouponInfo = (activityId) => {
  return request({
    url: '/app/activity/getNewUserCouponInfo',
    method: 'GET',
    params: { activityId }
  })
}
